module.exports = __webpack_public_path__ + "media/images/emblems/Tegerfelden-blason-6f487b1d9ef691554084e3daf7eebb6b.png";